import api from 'services/api'

export const fetchDepartments = () =>
  api.get('/departments')

export const fetchAllowedDepartmentsForRole = role =>
  api.get(`/departments/allowed-for-role/${role}`)
